var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wardrobe-materials"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.materials,"sort-options":{
      enabled: true,
      initialSortBy: {field: 'serialNumber', type: 'asc'}
    }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'materialAmount')?_c('span',[_vm._v(_vm._s(_vm._f("float")(props.row.materialAmount)))]):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }